<template>
  <div class="container">
    <h1 :class="$style['collections__title']">
      {{ route.params.slug[0] }}
    </h1>
    <section
      :class="$style['collections__collections']">
      <LazyTile
        v-for="collection in subNavigationForCollections"
        :key="collection.slug"
        :to="{ path: collection.slug }"
        :src="collection.image">
        <LazyHeading class="heading--tiny heading--white-black">
          Collection
        </LazyHeading>
        <LazyHeading class="heading--small-tiny">
          {{ collection.title }}
        </LazyHeading>
      </LazyTile>
    </section>
  </div>
</template>

<script setup>
const route = useRoute()
const { subNavigationForCollections, setCategory } = await useProducts()
await setCategory({
  categorySlug: route.params.slug[0]?.toLowerCase(),
  subCategorySlug: route.params.slug[1]?.toLowerCase() || null
})

</script>
<style lang="scss" module>
.collections {
  &__title {
    width: 100%;
    text-transform: capitalize;
    margin: 1rem 0;

  }

  &__collections {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    grid-gap: calc(var(--spacing ) * 2);
    width: 100%;

    @media (min-width: #{$breakpoint-mobile}) {
      grid-template-columns: repeat(auto-fill, minmax(286px, 1fr));
    }

    // Tablet and up
    @media (min-width: #{$breakpoint-tablet}) {
      padding: 0 calc(var(--spacing ) * 2);
      grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
      grid-gap: calc(var(--spacing ) * 6);
      padding-top: calc(var(--spacing ) * 2);
    }
  }

  @media (max-width: #{$breakpoint-tablet - 1}) {
    &__filters {
      display: none;
    }

    &__main {
      width: 100%;
    }
  }
}
</style>
